/**
 * @ngInject
 */
function run($rootScope, $window, $animate, $auth, flux, userStore, actions, $timeout, Tracking) {

	$animate.enabled(false);
	var authenticated = false;
	var registeredUserDimension = false;

	// we check first if user is Authenticated.. if not, we get the user.
	if($auth.isAuthenticated()){
		flux.dispatch('GET_USER');
		Tracking.setDimension("dimension1", "yes");
	}

	$rootScope.$on('$routeChangeSuccess', function(event, next, current) { 
		var path = next.originalPath == "/" ? location.pathname : location.pathname + next.originalPath;
		Tracking.trackPage(path);
	});

	// Logic for handling expired sessions on window focus
	function authChecker() {
		// Check if user was previously authenticated in this session - if so let's run the logout routine to avoid a user working on their data without being authenticated
		if(authenticated && !$auth.isAuthenticated()){
			// console.log("RUN.JS We WERE authenticated but not anymore, let's logout");
			authenticated = false;
			flux.dispatch('LOGOUT_USER', {});
		} else if($auth.isAuthenticated()){
			// console.log("RUN.JS Yes, we are authenticated. Let's remember this")
			authenticated = true;
		}
	}

	// Register user dimension once
	function onUserUpdated() {
		var user = userStore.getUser();
		if(!registeredUserDimension && angular.isDefined(user.id)){
			Tracking.setDimension("dimension2", user.id);
			registeredUserDimension = true;
		}
	}

	// listening to userStore object.. if it changes, run onUserUpdated() which impacts local scope
	$rootScope.$listenTo(userStore, ['user'], onUserUpdated);

	// we need to have this event just so we can logout user if he has leaved a page for some time and session is expired..
	// It checks it every time window is in focus.
	angular.element($window).bind('focus', function() {
		authChecker();
	});

	// check if we are authenticated on application load
	authChecker();
}